import React from "react";
import { Link } from "react-router-dom";
import { LEGAL_CENTER_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import { LEGAL_CARD_GROUPS, legalDocumentsInGroup, LEGAL_LAST_UPDATED } from "../../legal/legalRegistry";
import "./legal-pages.css";

export default function LegalCenterPage() {
  usePageSeo(LEGAL_CENTER_SEO);

  return (
    <div className="td-legal td-legal--center">
      <section className="td-legal-hero" aria-labelledby="td-legal-hero-title">
        <div className="td-legal-hero__bg" aria-hidden />
        <div className="td-legal-hero__grid" aria-hidden />
        <div className="td-legal-hero__vignette" aria-hidden />
        <div className="td-legal-hero__inner">
          <p className="td-legal-hero__eyebrow">Treydora archive · covenant vault</p>
          <h1 id="td-legal-hero-title" className="td-legal-hero__title">
            Rights, Access &amp; Platform Terms
          </h1>
          <p className="td-legal-hero__lead">
            The instruments below govern digital asset purchases, NFT licensing boundaries, virtual storefront access inside
            Oshar, marketplace participation where enabled, privacy practices, refunds, and how you may use Treydora
            services. They are written to be readable — but they are still legal instruments.
          </p>
          <p className="td-legal-hero__meta">
            <span className="td-legal-pill">Legal Center</span>
            <span className="td-legal-hero__date">Registry date · {LEGAL_LAST_UPDATED}</span>
          </p>
        </div>
      </section>

      <div className="td-legal-inner">
        {/* DEVELOPER: Starter copy across this center — attorney review required before launch. */}
        <aside className="td-legal-devcallout" role="note">
          <strong>Internal note.</strong> Policy text linked from this center is starter template content for engineering
          integration. Qualified counsel must review and replace with jurisdiction-specific language before reliance.
        </aside>

        {LEGAL_CARD_GROUPS.map((group) => {
          const docs = legalDocumentsInGroup(group.id);
          if (!docs.length) return null;
          return (
            <section key={group.id} className="td-legal-group" aria-labelledby={`td-legal-group-${group.id}`}>
              <header className="td-legal-group__head">
                <h2 id={`td-legal-group-${group.id}`} className="td-legal-group__title">
                  {group.title}
                </h2>
                <p className="td-legal-group__subtitle">{group.subtitle}</p>
                <div className="td-legal-group__rule" aria-hidden />
              </header>
              <div className="td-legal-card-grid">
                {docs.map((doc) => (
                  <article key={doc.slug} className={`td-legal-doc-card td-legal-doc-card--${doc.categoryTone}`}>
                    <div className="td-legal-doc-card__shine" aria-hidden />
                    <span className="td-legal-doc-card__badge">{doc.category}</span>
                    <h3 className="td-legal-doc-card__title">{doc.title}</h3>
                    <p className="td-legal-doc-card__desc">{doc.shortDescription}</p>
                    <Link className="td-legal-doc-card__cta" to={doc.path}>
                      View terms <span aria-hidden>↗</span>
                    </Link>
                  </article>
                ))}
              </div>
            </section>
          );
        })}

        <footer className="td-legal-center-foot">
          <p>
            Questions about these instruments?{" "}
            <a className="td-legal-inline-link" href="mailto:info@treydora.com?subject=Legal%20Center">
              info@treydora.com
            </a>
          </p>
        </footer>
      </div>
    </div>
  );
}
